var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartDelete = function SvgCartDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cart-delete_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8453C",
    d: "M14.164 5h4.167v1.667h-1.667V17.5a.833.833 0 0 1-.833.833H4.164a.834.834 0 0 1-.833-.833V6.667H1.664V5h4.167V2.5a.833.833 0 0 1 .833-.833h6.667a.833.833 0 0 1 .833.833zm.833 1.667h-10v10h10zm-7.5 2.5h1.667v5H7.497zm3.334 0h1.666v5h-1.666zM7.497 3.333V5h5V3.333z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cart-delete_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgCartDelete;